import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Alert } from 'react-bootstrap';

import { CTAButtons } from 'components';

import './style.scss';

function Hardware() {
  const navigate = useNavigate();
  const buttons = {
    next: {
      text: 'Continue',
      onClick: () => {
        navigate(`/hardware/integrations`);
      },
    },
  };
  return (
    <div className="hardware-intro d-flex flex-fill flex-column ">
      <div className="jumbotron">
        <p className="hardware-intro-description">
          In this section you would be able to configure all your hardware
          devices in a easy and convenient way. Press Continue to get started .
        </p>
      </div>
      <Alert variant="warning">
        Some of the integrations require the installation of Micro-Services. We
        have a smart Installer application that can manage all the
        Micro-Services. Go to{' '}
        <Link to="/hardware/installer">Installer documentation</Link> to find
        out more about it and see how to install it on your machine.
      </Alert>
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default Hardware;
